import axiosInstance from "../axios-instance";
import {
  DefinitionRolesResponse,
  PresentationRolesResponse,
  UpdateCategoryPreKeyRequest,
  UpdateCategoryPreKeyResponse,
} from "./types";

export const updateCategoryPreKey = async (
  workbookId: string,
  categoryId: string,
  request: UpdateCategoryPreKeyRequest,
): Promise<UpdateCategoryPreKeyResponse> => {
  const response = await axiosInstance.put(
    `/v1/workbooks/${workbookId}/categories/${categoryId}/pre-key`,
    request,
  );
  return response.data;
};

export const getAllPresentationRoles = async (
  workbookId: string,
): Promise<PresentationRolesResponse> => {
  const response = await axiosInstance.get(
    `/v1/workbooks/${workbookId}/presentation-roles`,
  );
  return response.data;
};

export const getDefinitionRolesByPresentation = async (
  workbookId: string,
  preKey: string,
): Promise<DefinitionRolesResponse> => {
  const response = await axiosInstance.get(
    `/v1/workbooks/${workbookId}/presentation-roles/${preKey}/definition-roles`,
  );
  return response.data;
};
